export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC=10;
export const RES_PER_PAGE=10;
export const KEY ='f11c3f07-16ae-4d12-978c-c5ca9f0e7c4f';
export const MODEL_CLOSE_SEC =2.5;